module.exports = __webpack_public_path__ + "img/56.62d444c9.jpg";